import type { LocationQuery } from 'vue-router';
import { firstString } from '#layers/base/public';

/**
 * Status of an SSO callback flow (login or account-linking). Sourced from
 * the `?auth=` or `?link=` query params on `/auth/callback`.
 */
export type CallbackStatus = 'success' | 'error' | undefined;

export function isCallbackStatus(value: unknown): value is CallbackStatus {
	return value === 'success' || value === 'error' || value === undefined;
}

/**
 * Whether `/auth/callback` only hands off: login success forwards into the app,
 * and both link outcomes forward to the page that started the link flow. Only
 * `auth=error` and a bare visit stay on the page to show the error alert.
 */
export function isCallbackHandoff(query: LocationQuery): boolean {
	const auth = firstString(query.auth);
	const link = firstString(query.link);
	if (auth === 'success') return true;
	if (auth === 'error') return false;
	return link === 'success' || link === 'error';
}
